'use client';

import type { Event_Entry } from '@/types/graphql';
import { formatDate } from '@/utils/dateFormat';

interface ShowDateTimeProps {
    event: Event_Entry;
    locale: string;
}

export default function ShowDateTimeInner({ event, locale }: ShowDateTimeProps) {
    const startDate = event.eventProgramStart;
    const endDate = event.eventProgramEnd;

    if (!startDate) return null;

    const formattedStartDate = formatDate.dayMonthYear(startDate, locale);
    const formattedStartTime = formatDate.time(startDate, locale);
    const formattedEndTime = formatDate.time(endDate || startDate, locale);

    return (
        <div>
            {formattedStartDate}
            <br />
            <span className="text-sm">
                {formattedStartTime} - {formattedEndTime}
            </span>
        </div>
    );
}
